module.exports = __webpack_public_path__ + "static/img/ikonaPrezentacja-OFF.c26e363c.png";